import {useSelector, useDispatch} from 'react-redux';
import {selectPaymentData, selectSelectedBanData, selectPaymentAction, selectGroupedBans} from '../DebtAndUpdatePaymentBlockSlice';
import {resetStore} from '../../SaleBlock/PaymentCG/PaymentCGSlice';
export const useDebtPaymentFailed = () => {
  const dispatch = useDispatch();
  const actions = {
    resetCGStore: () => dispatch(resetStore()),
  };

  return {
    actions,
  };
};
